import { PronounsEnum } from '@/graphql/generated'

const getPronounsText = (pronouns: PronounsEnum): string => {
  switch (pronouns) {
    case PronounsEnum.HeHim:
      return 'He/Him'
    case PronounsEnum.SheHer:
      return 'She/Her'
    case PronounsEnum.TheyThem:
      return 'They/Them'
    case PronounsEnum.RatherNotSay:
      return ''
  }
}

export const getPronounsLabel = (pronouns: PronounsEnum | undefined, withBrackets = true): string => {
  const pronounsText = pronouns ? getPronounsText(pronouns) : ''
  return withBrackets && pronounsText ? `${pronounsText}` : pronounsText
}
